import {css, StyleSheet} from "aphrodite";
import React from 'react';
import GridStyles from "../styles/styles";
import Config from "../config/Config";
import MediaQuery from "../styles/MediaQuery";

const FeatureTickList = ({extraStyle, list}) => {
    const styles = StyleSheet.create({
        container: {
            ...GridStyles.define("repeat(auto-fill, minmax(28px, auto))", "1fr"),
            fontSize: 16,
            fontWeight: 600,
            lineHeight: 1.75,
            gridRowGap: 6
        },
        feature: {
            ...GridStyles.define("auto", "20px 16px auto"),
            alignItems: "center"
        },
        tick: {
            height: 20,
            width: 20,
            marginRight: 16,
            gridColumn: 1
        },
        text: {
            gridColumn: 3,
            ...MediaQuery.mobile({
                textAlign: "left",
                lineHeight: 1.5,
                fontWeight: 500
            })
        }
    });

    return (
        <div className={css(styles.container, extraStyle)}>
            {list.map((item, index) => (
                <div className={css(styles.feature)} key={index}>
                    <img className={css(styles.tick)} src={Config.images.FEATURE_TICK} alt=""/>
                    <span className={css(styles.text)}>{item}</span>
                </div>
            ))}
        </div>
    );
};

export default FeatureTickList;
